<template>
  <div>
    <base-title-bar-scroll-page ref="container" :show-title-bar="false" title="订单登记">
      <div class="page-shell">
        <div class="top-bar">订单登记</div>
        <div class="hero-section">
          <div class="logo-wrap">
            <img alt="Logo" class="logo" :src="logoUrl" @error="useDefaultLogo">
          </div>
          <div class="hero-copy">
            <div class="hospital-name">{{ hospitalName || '医院' }}</div>
            <div class="business-name">{{ businessName || '业务登记' }}</div>
          </div>
        </div>

        <div class="form-panel">
          <van-field
            v-model="patientName"
            label="姓名"
            placeholder="请输入姓名"
            required
            type="text"
          />
          <van-field
            v-model="patientMobile"
            label="手机号"
            placeholder="请输入手机号"
            required
            type="tel"
          />
          <van-field
            readonly
            clickable
            required
            label="科室"
            :value="departmentName"
            placeholder="请选择科室"
            @click="openDepartmentPicker"
          />
          <van-field
            readonly
            clickable
            required
            label="医生"
            :value="doctorName"
            placeholder="请选择医生"
            @click="openDoctorPicker"
          />
        </div>

        <div class="remark-panel">
          <van-field
            v-model="remark"
            class="remark-field"
            placeholder="请输入备注"
            rows="3"
            type="textarea"
          />
        </div>

        <div class="button-wrapper">
          <van-button class="submit-button" type="primary" :loading="submitting" @click="submitBind">提交登记</van-button>
        </div>
        <div class="bottom-info">
          <div v-if="sponsorName" class="sponsor">
            <span v-if="sponsorName" class="sponsor-name">{{ sponsorName }}</span>
          </div>
          <div class="footer">技术支持：动优远程康复服务云平台</div>
        </div>
      </div>
    </base-title-bar-scroll-page>

    <van-popup v-model="showDepartmentPicker" round position="bottom">
      <div class="option-popup">
        <div class="option-header">
          <button class="option-cancel" type="button" @click="showDepartmentPicker = false">取消</button>
          <div class="option-title">选择科室</div>
          <button class="option-cancel option-placeholder" type="button">取消</button>
        </div>
        <div class="option-grid department-grid">
          <button
            v-for="department in departmentDoctorOptions"
            :key="department.departmentName"
            class="option-cell"
            :class="{ active: departmentName === department.departmentName }"
            type="button"
            @click="onDepartmentConfirm(department.departmentName)"
          >
            {{ department.departmentName }}
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showDoctorPicker" round position="bottom">
      <div class="option-popup">
        <div class="option-header">
          <button class="option-cancel" type="button" @click="showDoctorPicker = false">取消</button>
          <div class="option-title">选择医生</div>
          <button class="option-cancel option-placeholder" type="button">取消</button>
        </div>
        <div class="option-grid doctor-grid">
          <button
            v-for="doctor in doctorColumns"
            :key="doctor"
            class="option-cell"
            :class="{ active: doctorName === doctor }"
            type="button"
            @click="onDoctorConfirm(doctor)"
          >
            {{ doctor }}
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showSuccess" :close-on-click-overlay="false" class="popup-wrapper" position="bottom">
      <div class="success-content">
        <img alt="Success Logo" class="success-logo" src="https://cdn.keihong.tech/img/202312211813200.png">
        <div class="success-message">登记成功</div>
        <div class="order-no">登记单号：{{ bindOrderNo }}</div>
        <van-button style="width: 100%;" type="primary" @click="finish">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import BaseTitleBarScrollPage from '@/h5/doucan/components/BaseTitleBarScrollPage.vue'
import { Notify } from 'vant'
import ExternalPaidOrderDao from '@/h5/doucan/network/ExternalPaidOrderDao'

const HOSPITAL_DEPARTMENT_DOCTOR_OPTIONS = {
  暨南大学附属顺德医院: [
    {
      departmentName: '康复医学科',
      doctors: [
        '尹德铭',
        '何志坚',
        '胡旭慧',
        '方向延',
        '李志强',
        '朱智文',
        '潘冠佳',
        '毕娟',
        '赵建华',
        '王悦',
        '邓恩情',
        '冯宗勤',
        '何凤意',
        '李广源',
        '朱墨飞'
      ]
    },
    {
      departmentName: '骨一科|创伤骨科',
      doctors: [
        '吴春辉',
        '黎凌云',
        '陈小磊',
        '谢伟健',
        '唐迎春',
        '李康',
        '杨勇',
        '郑鸿坚',
        '段礼良',
        '麦绍声',
        '张力予',
        '余君',
        '李洁云',
        '谭丹',
        '陈斯欣',
        '成彩芬',
        '伍翠仪',
        '谷珍荣',
        '黄楚晏',
        '肖楚涵',
        '文区'
      ]
    },
    {
      departmentName: '骨二科|脊柱外科',
      doctors: [
        '宋兴华',
        '查丁胜',
        '徐自强',
        '蔡跃波',
        '姚华灿',
        '陈计稳',
        '蔡社兴',
        '李笑芬',
        '杨丽',
        '曹辉',
        '李翠莲',
        '吴桂荣',
        '梁春梅',
        '李文军',
        '陈俊杰',
        '叶自由',
        '李梦婷',
        '周悦虹',
        '周坤兰'
      ]
    },
    {
      departmentName: '神经外科',
      doctors: [
        '王晓东',
        '吴烁龙',
        '潘珏恒',
        '郑颖锋',
        '马劲翔',
        '梁金凤',
        '梁敏仪',
        '陈祝娇',
        '陈秋婷',
        '张翠媚',
        '韩君梅',
        '赵雅丽',
        '袁玉霞',
        '沈燕雯',
        '苏彩霞',
        '魏雪聪',
        '陈若茵'
      ]
    },
    {
      departmentName: '神经内科',
      doctors: [
        '黄立安',
        '毕伟',
        '乔宏宇',
        '朱慧丽',
        '董大伟',
        '何深文',
        '贺丽萍',
        '杨丽',
        '宋雪珠',
        '吴玉莹',
        '陈怡',
        '樊月映',
        '王艳军',
        '李晓莹',
        '陈欢',
        '吴静文',
        '胡嘉媚',
        '黄燕芳',
        '吴祥雄',
        '唐耀',
        '杨延丽',
        '柯世琴',
        '张小红',
        '曾翠娟',
        '罗三妹',
        '黄文萍',
        '陈敏',
        '梁慧诗'
      ]
    }
  ]
}

export default {
  name: 'ExternalPaidOrderBindPage',
  components: { BaseTitleBarScrollPage },
  data () {
    return {
      hospitalName: '',
      businessCode: '',
      businessName: '',
      logoUrl: '',
      defaultLogoUrl: 'https://cdn.keihong.tech/20260615114345789.png',
      sponsorName: '',
      patientName: '',
      patientMobile: '',
      departmentName: '',
      doctorName: '',
      remark: '',
      departmentDoctorOptions: [],
      showDepartmentPicker: false,
      showDoctorPicker: false,
      showSuccess: false,
      bindOrderNo: '',
      submitting: false
    }
  },
  computed: {
    departmentColumns () {
      return this.departmentDoctorOptions.map(item => item.departmentName)
    },
    doctorColumns () {
      const department = this.departmentDoctorOptions.find(item => item.departmentName === this.departmentName)
      return department ? department.doctors : []
    }
  },
  async mounted () {
    this.$refs.container.stopLoading()
    this.hospitalName = this.$route.query.hospitalName || this.$route.query.hospital || ''
    this.businessCode = this.$route.query.businessCode || ''
    this.businessName = this.$route.query.businessName || ''
    this.logoUrl = this.$route.query.logoUrl || this.defaultLogoUrl
    this.sponsorName = this.$route.query.sponsorName || ''
    this.departmentDoctorOptions = this.getDepartmentDoctorOptions(this.hospitalName)
    if (!this.hospitalName || !this.businessCode || !this.businessName) {
      Notify({ type: 'danger', message: '页面参数不完整' })
    }
  },
  methods: {
    getDepartmentDoctorOptions (hospitalName) {
      const options = HOSPITAL_DEPARTMENT_DOCTOR_OPTIONS[hospitalName]
      return options ? options.map(item => ({
        departmentName: item.departmentName,
        doctors: [...item.doctors]
      })) : []
    },
    useDefaultLogo () {
      if (this.logoUrl !== this.defaultLogoUrl) {
        this.logoUrl = this.defaultLogoUrl
      }
    },
    openDepartmentPicker () {
      if (!this.departmentColumns.length) {
        Notify({ type: 'warning', message: '暂无可选科室' })
        return
      }
      this.showDepartmentPicker = true
    },
    openDoctorPicker () {
      if (!this.departmentName) {
        Notify({ type: 'warning', message: '请先选择科室' })
        return
      }
      if (!this.doctorColumns.length) {
        Notify({ type: 'warning', message: '该科室暂无可选医生' })
        return
      }
      this.showDoctorPicker = true
    },
    onDepartmentConfirm (value) {
      this.departmentName = value
      this.doctorName = ''
      this.showDepartmentPicker = false
    },
    onDoctorConfirm (value) {
      this.doctorName = value
      this.showDoctorPicker = false
    },
    validate () {
      if (!this.patientName || !this.patientMobile) {
        Notify({ type: 'danger', message: '请填写姓名和手机号' })
        return false
      }
      if (!/^1\d{10}$/.test(this.patientMobile)) {
        Notify({ type: 'danger', message: '手机号格式不正确' })
        return false
      }
      if (!this.departmentName) {
        Notify({ type: 'danger', message: '请选择科室' })
        return false
      }
      if (!this.doctorName) {
        Notify({ type: 'danger', message: '请选择医生' })
        return false
      }
      return true
    },
    async submitBind () {
      if (!this.validate()) return
      this.submitting = true
      const resp = await ExternalPaidOrderDao.bind({
        businessCode: this.businessCode,
        businessName: this.businessName,
        hospitalName: this.hospitalName,
        departmentName: this.departmentName,
        doctorName: this.doctorName,
        patientName: this.patientName,
        patientMobile: this.patientMobile,
        remark: this.remark
      })
      this.submitting = false
      if (resp.code !== 1) {
        Notify({ type: 'danger', message: resp.msg || '提交失败' })
        return
      }
      this.bindOrderNo = resp.data.bindOrderNo
      this.showSuccess = true
    },
    finish () {
      this.showSuccess = false
      this.patientName = ''
      this.patientMobile = ''
      this.departmentName = ''
      this.doctorName = ''
      this.remark = ''
    }
  }
}
</script>

<style scoped>
.page-shell {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5fbf9 0%, #eef4f7 42%, #f4f6f8 100%);
  padding: 0 0 112px;
}

.top-bar {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 52px;
  line-height: 52px;
  background-color: rgba(255, 255, 255, 0.96);
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 1px 0 rgba(31, 45, 61, 0.06);
}

.hero-section {
  display: flex;
  align-items: center;
  min-height: 112px;
  margin: 0 0 14px;
  padding: 22px 36px;
  background: linear-gradient(135deg, #e9fff7 0%, #f8fffd 48%, #eef7ff 100%);
}

.logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  margin-right: 16px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.78);
  box-shadow: inset 0 0 0 1px rgba(21, 181, 137, 0.1);
}

.logo {
  width: 58px;
  height: 58px;
  border-radius: 16px;
  object-fit: cover;
}

.hero-copy {
  min-width: 0;
}

.hospital-name {
  color: #1f2933;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  word-break: break-word;
}

.business-name {
  margin-top: 8px;
  color: #5f6f7a;
  font-size: 14px;
  line-height: 20px;
  word-break: break-word;
}

.form-panel {
  margin: 0 16px;
  border-radius: 9px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.06);
}

.form-panel ::v-deep .van-field {
  min-height: 58px;
  padding: 18px 16px;
}

.form-panel ::v-deep .van-field:not(:last-child)::after {
  left: 16px;
  right: 16px;
  border-bottom-color: #eef1f4;
}

.form-panel ::v-deep .van-field__label {
  width: 86px;
  color: #4e5963;
  font-size: 16px;
  font-weight: 600;
}

.form-panel ::v-deep .van-field__control {
  color: #1f2933;
  font-size: 16px;
}

.form-panel ::v-deep .van-field__control::placeholder {
  color: #b6bec6;
}

.remark-panel {
  margin: 14px 16px 0;
  border-radius: 9px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.05);
}

.remark-field {
  min-height: 64px;
  padding: 18px 16px;
}

.remark-field ::v-deep .van-field__control {
  color: #1f2933;
  font-size: 16px;
  line-height: 24px;
}

.remark-field ::v-deep .van-field__control::placeholder {
  color: #b6bec6;
}

.button-wrapper {
  margin: 18px 16px 0;
}

.submit-button {
  width: 100%;
  height: 52px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(135deg, #11c884 0%, #0fbf75 100%);
  box-shadow: 0 10px 18px rgba(15, 191, 117, 0.2);
  font-size: 17px;
  font-weight: 700;
}

.bottom-info {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(244, 246, 248, 0.78) 0%, #f4f6f8 24%);
  padding: 10px 0 12px;
}

.sponsor {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  margin-bottom: 2px;
  color: #68747f;
  font-size: 14px;
  font-weight: 600;
}

.sponsor-name {
  max-width: 72vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer {
  font-size: 13px;
  text-align: center;
  color: #8a949d;
}

.option-popup {
  max-height: 72vh;
  padding: 0 16px 24px;
  background-color: #fff;
}

.option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
}

.option-title {
  color: #1f2933;
  font-size: 16px;
  font-weight: 700;
}

.option-cancel {
  border: 0;
  background: transparent;
  color: #6b7785;
  font-size: 14px;
  line-height: 24px;
}

.option-placeholder {
  visibility: hidden;
}

.option-grid {
  display: grid;
  gap: 10px;
  max-height: 58vh;
  overflow-y: auto;
  padding: 8px 0 2px;
}

.department-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.doctor-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.option-cell {
  min-width: 0;
  min-height: 44px;
  padding: 8px 6px;
  border: 1px solid #e5eaf0;
  border-radius: 7px;
  background-color: #f8fafb;
  color: #3f4c59;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  word-break: break-word;
}

.option-cell.active {
  border-color: #11c884;
  background-color: #eafff6;
  color: #0aa86d;
}

.popup-wrapper {
  height: 50vh;
}

.success-content {
  padding: 16px;
  text-align: center;
}

.success-logo {
  width: 70px;
  height: 70px;
  margin: 0 auto;
}

.success-message {
  text-align: center;
  font-size: 20px;
  margin: 20px 0;
}

.order-no {
  text-align: center;
  font-size: 14px;
  margin: 20px 0;
}
</style>
